import { render } from "./IncontournablesProduct.vue?vue&type=template&id=a8ef03bc&scoped=true"
import script from "./IncontournablesProduct.vue?vue&type=script&lang=js"
export * from "./IncontournablesProduct.vue?vue&type=script&lang=js"

import "./IncontournablesProduct.vue?vue&type=style&index=0&id=a8ef03bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ef03bc"]])

export default __exports__